import { CLEAR_SITE_DATA } from '../application';
import {
  DESTROY_FILES_SESSION,
  REQUEST_FILES,
  RECEIVE_FILES,
  RECEIVE_INSTRUCTIONALS,
  DELETE_FILE_SUCCESS,
  UPLOAD_FILE_STARTED,
  UPLOAD_FILE_COMPLETED,
  CLEAR_UPLOADED,
  CREATE_BOOKMARK_SUCCESS,
  UPDATE_BOOKMARK_SUCCESS,
  DELETE_BOOKMARK_SUCCESS,
} from './actions';

const initialState = {
  sessions: {},
  fileObjects: {},
  instructionals: {},
  uploading: {},
  uploaded: {},
  zipping: [],
};

export const reducer = (state = structuredClone(initialState), action) => {
  switch (action.type) {
    case DESTROY_FILES_SESSION: {
      const sessions = { ...state.sessions };
      delete sessions[action.sessionId];

      return { ...state, sessions };
    }
    case REQUEST_FILES: {
      if (state.sessions[action.sessionId]) {
        return {
          ...state,
          sessions: {
            ...state.sessions,
            [action.sessionId]: {
              ...state.sessions[action.sessionId],
              loading: true,
            },
          },
        };
      }
      return state;
    }
    case RECEIVE_FILES: {
      const { sessionId, files, pages, query } = action;
      const fileObjects = { ...state.fileObjects };

      for (const file of files) {
        fileObjects[file.id] = file;
      }

      return {
        ...state,
        fileObjects,
        sessions: {
          ...state.sessions,
          [sessionId]: {
            files: files.map((f) => f.id),
            pages,
            query,
            loading: false,
          },
        },
      };
    }
    case RECEIVE_INSTRUCTIONALS: {
      return {
        ...state,
        instructionals: Object.fromEntries(
          action.files.filter((file) => file.context.name).map((file) => [file.context.name, file])
        ),
      };
    }
    case DELETE_FILE_SUCCESS: {
      const fileObjects = { ...state.fileObjects };
      delete fileObjects[action.fileId];

      return { ...state, fileObjects };
    }
    case CREATE_BOOKMARK_SUCCESS: {
      const { fileId, bookmark } = action;
      const fileObjects = { ...state.fileObjects };

      fileObjects[fileId].bookmarks = [...fileObjects[fileId].bookmarks, bookmark];

      return { ...state, fileObjects };
    }
    case UPDATE_BOOKMARK_SUCCESS: {
      const { fileId, bookmarkId, bookmark } = action;
      const fileObjects = { ...state.fileObjects };

      fileObjects[fileId].bookmarks = [
        ...fileObjects[fileId].bookmarks.filter(({ id }) => id !== bookmarkId),
        bookmark,
      ];

      return { ...state, fileObjects };
    }
    case DELETE_BOOKMARK_SUCCESS: {
      const { fileId, bookmarkId } = action;
      const fileObjects = { ...state.fileObjects };

      if (fileObjects[fileId]) {
        fileObjects[fileId].bookmarks = fileObjects[fileId].bookmarks.filter(
          ({ id }) => id !== bookmarkId
        );
      }

      return { ...state, fileObjects };
    }
    case UPLOAD_FILE_STARTED: {
      return {
        ...state,
        uploading: {
          ...state.uploading,
          [action.file.clientIdentifier]: action.file,
        },
      };
    }
    case UPLOAD_FILE_COMPLETED: {
      const { file, status } = action;
      const newUploading = { ...state.uploading };
      const uploadedFiles = {
        ...state.uploaded,
        [file.clientIdentifier]: { ...file, status },
      };
      const uploadedNumber = Object.entries(uploadedFiles).filter(([, v]) =>
        ['SUCCESS'].includes(v.status)
      );
      delete newUploading[file.clientIdentifier];
      return {
        ...state,
        uploading: newUploading,
        uploaded: uploadedFiles,
        totalFilesUploaded: uploadedNumber.length,
      };
    }
    case CLEAR_UPLOADED: {
      return { ...state, uploaded: {} };
    }
    case CLEAR_SITE_DATA: {
      return {
        ...structuredClone(initialState),
        // Kept across the reset as they are common to all relams/sites.
        instructionals: state.instructionals,
      };
    }
    default: {
      return state;
    }
  }
};
